import { render, staticRenderFns } from "./goodUrl.vue?vue&type=template&id=65def409"
import script from "./goodUrl.vue?vue&type=script&lang=js"
export * from "./goodUrl.vue?vue&type=script&lang=js"
import style0 from "./goodUrl.vue?vue&type=style&index=0&id=65def409&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports